// extracted by mini-css-extract-plugin
module.exports = {"TaskScreen":"TaskScreen_TaskScreen__3_Qt5"};